<template>
  <v-bottom-sheet v-if="CONFIG.config.tools.indexOf('layerControl') > -1" :value="value" activator="#footer-layercontrol-btn">
    <v-card style="max-height: 70vh; overflow-y: auto">
      <v-list color="primary" dark>
        <collection v-for="(collection, col) in LAYERS"
                    :collection="collection">
          <layer-control-layer v-for="layer in collection.layers"
                               text-color="white"
                               :layer="layer"></layer-control-layer>
        </collection>
      </v-list>
    </v-card>
  </v-bottom-sheet>
</template>

<style scoped>

</style>

<script>
import LayerControl from '@/components/SideBar/LayerControl.vue';
import { mapGetters, mapState } from 'vuex';
import LayerLegend from '@/components/SideBar/LayerLegend.vue';
import LayerControlLayer from '@/components/SideBar/LayerControlLayer.vue';
import Collection from '@/components/LayerControl/Collection.vue';

export default {
  name: 'MobileLayerControl',
  components: {
    Collection,
    LayerControlLayer,
    LayerLegend,
    LayerControl
  },
  computed: {
    ...mapGetters('layers', {
      LAYERS: 'LAYERCONTROL_DATA',
      LEGEND: 'LEGEND',
    }),
    ...mapGetters(['CONFIG']),
    ...mapState('layers', ['active']),
  },
  props: {
    value: {
      type: Boolean,
      default: false
    }
  }
};
</script>
